import { AuthApiService } from "../service/authService";
import { refreshTokenMiddleware } from "../api/loginAPI";
export const verifyIsAuthenticated = async () => {
  const token = localStorage.getItem("accessToken");
  if (!token || isTokenExpired(token)) {
    try {
      const newToken = await refreshTokenMiddleware();
      if (newToken && !isTokenExpired(newToken)) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  return true;
};

export const getUserRoleFromLocalStorage = () => {
  const allKeys = Object.keys(localStorage);
  let userRoleKey = "";
  allKeys.forEach((key) => {
    if (key.includes("userRole")) {
      userRoleKey = key;
    }
  });
  return localStorage.getItem(userRoleKey);
};

const isTokenExpired = (token: any) => {
  const decodedToken = decodeToken(token);
  return decodedToken.exp * 1000 < Date.now(); // Check token expiration
};

const decodeToken = (token: any) => {
  const payload = token.split(".")[1];
  return JSON.parse(atob(payload)); // Decode JWT token
};
